<template>

    <Tutela></Tutela>
  
</template>
  
  <script>
  import Tutela from '../components/pratiche/Tutela.vue';
  
  export default {
    pageName: 'Tutela',
    components: {
        Tutela
    },
    data() {
      return {
  
      }
    },
  
    created(){
      
    },
  
    mounted(){
      
    },
  
    methods: {
      
    },
  }
  </script>